import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from 'components/mui';
import { CustomerOption } from 'containers/pages/addressManagement/types';

interface CustomerSelectorProps {
  value: CustomerOption | null;
  customers: CustomerOption[];
  onChange: (event: unknown, newValue: CustomerOption | null) => void;
  isLoading?: boolean;
}

function CustomerSelector({
  value,
  customers,
  onChange,
  isLoading = false,
}: CustomerSelectorProps) {
  return (
    <Autocomplete
      value={value}
      options={customers}
      getOptionLabel={(option) => option.Name || ''}
      isOptionEqualToValue={(option, val) => option.Id === val.Id}
      onChange={onChange}
      loading={isLoading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Customer"
          placeholder="Search customers..."
          size="small"
        />
      )}
      size="small"
      fullWidth
    />
  );
}

export default CustomerSelector;
